"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../utils/");
var _constants = require("../../constants/");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Creates a scene that emphasizes one presenter on the left.
 * The rest of the presenters form grid on the right.
 * @param {Array} sources
 * @param {{}} sourceStyle
 */

function featuredPresenterBuilder(sources) {
  var sourceStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var TILE_MARGIN = _utils.SCENE_WIDTH * 4 / 672;
  var camSources = (0, _utils.getCameraSources)(sources);
  return {
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    _id: 'sceneFeaturedPresenter',
    style: _objectSpread({}, _utils.COMMON_SCENE_STYLES),
    title: _constants.FEATURED_PRESENTER.title,
    description: _constants.FEATURED_PRESENTER.title,
    layers: camSources.map(function (source, sourceIndex) {
      var tileStyles = {};
      var sourceNum = sourceIndex + 1;
      var camSourceCount = Math.min(camSources.length, _utils.MAX_CAMERA_COUNT);
      var gridWidth = _utils.SCENE_WIDTH * 375 / 672;
      var featuredWidth = _utils.SCENE_WIDTH * 212 / 672;
      var featuredHeight = _utils.SCENE_HEIGHT * 298 / 378;
      var masterTopOffset = _utils.SCENE_HEIGHT * 40 / 378;
      var masterLeftOffset = _utils.SCENE_WIDTH * 40 / 672;
      var featuredRightOffset = _utils.SCENE_WIDTH * 5 / 672;
      var secondaryLeftOffset = masterLeftOffset + featuredWidth + featuredRightOffset;
      if (sourceNum === 1) {
        // Featured
        tileStyles = {
          top: masterTopOffset,
          width: featuredWidth,
          left: masterLeftOffset,
          height: featuredHeight
        };
      } else {
        var oneRowTileHeight = _utils.SCENE_HEIGHT * 186 / 378;
        // Secondary
        if (camSourceCount <= 2) {
          // Just one secondary source
          tileStyles = {
            height: oneRowTileHeight,
            left: secondaryLeftOffset,
            width: _utils.SCENE_WIDTH * 375 / 672,
            top: (_utils.SCENE_HEIGHT - oneRowTileHeight) / 2
          };
        } else {
          /**
           * Many secondary sources
           * less one for the featured source
           */
          var gridSourceNum = sourceNum - 1;
          var gridSourceIndex = sourceIndex - 1;
          var gridSourceCount = camSourceCount - 1;
          var gridConfig = _utils.gridConfigMap[gridSourceCount];
          var rawTileWidth = gridWidth / gridConfig.row1Count;
          var tileWidth = (gridWidth - TILE_MARGIN * (gridConfig.row1Count - 1)) / gridConfig.row1Count;
          var tileHeight = gridSourceCount === 2 ? oneRowTileHeight : (featuredHeight - TILE_MARGIN) / 2;
          var isRow1 = gridSourceNum <= gridConfig.row1Count;
          var topOffset = isRow1 ? gridConfig.row2Count === 0 ? (_utils.SCENE_HEIGHT - tileHeight) / 2 : masterTopOffset : masterTopOffset + tileHeight + TILE_MARGIN;
          var row2ExtraLeftOffset = (gridWidth - rawTileWidth * gridConfig.row2Count) / 2;
          var leftOffset = isRow1 ? (tileWidth + TILE_MARGIN) * gridSourceIndex : (tileWidth + TILE_MARGIN) * (gridSourceIndex - gridConfig.row1Count) + row2ExtraLeftOffset;
          tileStyles = {
            top: topOffset,
            width: tileWidth,
            height: tileHeight,
            left: secondaryLeftOffset + leftOffset
          };
        }
      }
      var bannerPosition = (0, _utils.getPresenterBannerPosition)(tileStyles);
      return {
        _id: source._id,
        source: source,
        layer: {
          animation: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION.animate), {}, {
              top: tileStyles.top,
              left: tileStyles.left,
              width: tileStyles.width,
              height: tileStyles.height
            })
          }),
          style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.styles), {}, {
            top: 0,
            left: 0,
            zIndex: sourceNum,
            position: 'absolute',
            mediaStyle: _objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.mediaStyles), {}, {
              width: tileStyles.width,
              height: tileStyles.height
            })
          }, tileStyles), sourceStyle), {}, {
            bannerStyles: _objectSpread(_objectSpread(_objectSpread({}, bannerPosition), _utils.extraPresenterBannerStyles), {}, {
              zIndex: sourceNum
            }),
            bannerAnimation: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION), {}, {
              animate: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION.animate), {}, {
                top: bannerPosition.top - 40,
                left: bannerPosition.left
              })
            })
          })
        }
      };
    })
  };
}
var _default = exports["default"] = featuredPresenterBuilder;